import { useEffect } from 'react'
import { checkPhoneEmail } from './useCheckPhoneEmailCustomHook'
import useDebounce from '../utils/useDebounce'
import { State } from '../state-actions-reducers'

interface Args {
  state: State
  setValue: (field: any, value: any, options?: any) => void
  accountForm: any
  lang: string
}

export function usePhoneEmailCheck({ state, setValue, accountForm, lang }: Args) {
  const phone = state.mobilePhoneNumbers[0]
  const email = state.emails[0]
  const debouncedPhone = useDebounce(phone, 1500)
  const debouncedMail = useDebounce(email, 1500)

  function handleError() {
    setValue('serverError', true, { shouldDirty: true })
    alert(accountForm.serverError[lang])
  }

  useEffect(() => {
    if (!debouncedPhone || debouncedPhone.length <= 2) {
      setValue('isPhoneOk', true, { shouldDirty: true })
      return
    }
    checkPhoneEmail(state, debouncedPhone, debouncedMail)
      .then(res => {
        if (res.message !== 'Invalid token') {
          setValue('isPhoneOk', res.isPhoneOk, { shouldDirty: true })
        } else {
          handleError()
        }
      })
      .catch(handleError)
  }, [debouncedPhone])

  useEffect(() => {
    if (!debouncedMail) {
      setValue('isEmailOk', true, { shouldDirty: true })
      return
    }
    checkPhoneEmail(state, debouncedPhone, debouncedMail)
      .then(res => {
        if (res.message !== 'Invalid token') {
          setValue('isEmailOk', res.isEmailOk, { shouldDirty: true })
        } else {
          handleError()
        }
      })
      .catch(handleError)
  }, [debouncedMail])
}
